export const socialProviders = {
  FACEBOOK: "facebook"
};
